import Avatar from '@sdk/components/avatar/Avatar';
import { useSession } from '@sdk/session/SessionContext';
import gettext from '@sdk/lang/gettext';

import TextEditor from '@web/richText/TextEditor';
import { Wrapper } from '@web/newsfeed/Article/ArticleComments/ArticleCommentEditor/articleCommentEditor.styles';
import { useArticleCommentEditor } from '@web/newsfeed/Article/ArticleComments/ArticleCommentEditor/articleCommentEditor.hooks';

type Props = {
  articleId: number;
  pageId: number;
};

export const ArticleCommentEditor = ({ articleId, pageId }: Props) => {
  const { currentUser } = useSession();
  const { onSubmit, mentionPersonas } = useArticleCommentEditor(articleId, pageId);

  return (
    <Wrapper>
      <Avatar user={currentUser} />
      <TextEditor
        gifPickerEnabled={false}
        submitLabel={gettext('Send')}
        onSubmit={onSubmit}
        hiddenToolbarControls
        personas={mentionPersonas}
      />
    </Wrapper>
  );
};
